import { render, staticRenderFns } from "./ActivationBriefProductsProvider.vue?vue&type=template&id=7bdd33ef&"
import script from "./ActivationBriefProductsProvider.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefProductsProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports